module.exports = __webpack_public_path__ + "img/base_activites_terrain_de_sport.a006b2a8.svg";